<script lang="ts">
  import { Input } from "$lib/components/ui/input";
  import { Label } from "$lib/components/ui/label";
  import { t } from "$lib/i18n";

  let {
    width = $bindable(0),
    height = $bindable(0),
    isReadonly = false,
  }: { width: number; height: number; isReadonly?: boolean } = $props();
</script>

<div class="grid grid-cols-4 items-center gap-4">
  <Label class="text-right">{$t('fields.size')}</Label>
  <div class="col-span-3 flex items-center gap-2">
    <Label for="size_width">{$t('fields.width')}:</Label>
    {#if isReadonly}
      <span class="text-sm">{width} {$t('fields.mm')}</span>
    {:else}
      <Input id="size_width" type="number" min="0" bind:value={width} class="w-24" />
      <span class="text-sm text-muted-foreground">{$t('fields.mm')}</span>
    {/if}
    <Label for="size_height" class="ml-2">{$t('fields.height')}:</Label>
    {#if isReadonly}
      <span class="text-sm">{height} {$t('fields.mm')}</span>
    {:else}
      <Input id="size_height" type="number" min="0" bind:value={height} class="w-24" />
      <span class="text-sm text-muted-foreground">{$t('fields.mm')}</span>
    {/if}
  </div>
</div>
